import { getCurrentClientDbName } from "@/api/wencesApi";
import { dbNameMatchesTenant } from "@/utils/dbNameMatchesTenant";

/**
 * Tenants que pagan el gasto de una sola vez: no hay etapa de "pedir el pago"
 * y después marcarlo pagado; al pagar, el pago queda guardado ya como pagado.
 */
const PAY_WITHOUT_REQUEST_TENANTS = ["nibiru"];

export function expensesArePaidWithoutRequest() {
  const dbName = getCurrentClientDbName();
  return PAY_WITHOUT_REQUEST_TENANTS.some((t) => dbNameMatchesTenant(dbName, t));
}
